<template>
  <div class="scheduler_section">
    <div class="">
      <span class="activity-mode pt-20 mb-22 clearfix survey_qs">
        <span :class="{ selected: activitySchedulingMode === 'schedule' }" @click="changeActivityMode('schedule')"><img alt="Scheduled" :src="activityModeIcon['schedule']" width="29" />&nbsp;&nbsp;Scheduled</span>
        <span :class="{ selected: activitySchedulingMode === 'both' }" @click="changeActivityMode('both')"><img alt="Scheduled and on-demand" :src="activityModeIcon['both']" width="58" />&nbsp;&nbsp;Both scheduled and on-demand</span>
        <span :class="{ selected: activitySchedulingMode === 'onDemand' }" @click="changeActivityMode('onDemand')"><img alt="On-demand only" :src="activityModeIcon['onDemand']" width="29" />&nbsp;&nbsp;On-demand only</span>
        <span v-show="showDynamicOnly" :class="{ selected: activitySchedulingMode === 'dynamicOnly' }" @click="changeActivityMode('dynamicOnly')"
          ><img
            alt="Dynamic only"
            :class="{
              'selected-mode': activitySchedulingMode === 'dynamicOnly',
              'unselected-mode': activitySchedulingMode !== 'dynamicOnly'
            }"
            class="circular-image"
            :src="activityModeIcon['dynamicOnly']"
            width="29"
          />&nbsp;&nbsp;Dynamic only</span
        >
      </span>
      <div class="pt-10 mb-2 clearfix dynamic-only-qs" v-show="activitySchedulingMode === 'dynamicOnly'">
        Note: This activity will only be triggered by a predefined dynamic scheduling event.
      </div>
    </div>
    <div
      :class="{
        'activity-mode-opacity': activitySchedulingMode === 'onDemand' || activitySchedulingMode === 'dynamicOnly'
      }"
    >
      <div class="scheduler_types">
        <div class="pt-20 clearfix survey_b pb-5">
          How would you like your
          <span v-if="options.type == 'Form'">activity</span>
          <span v-else>packet</span> to be sent?
        </div>
        <span class="scheduler_type" :class="{ active_item: scheduler.scheduleType === 'milestone' }" v-on:click="changeType('milestone')">
          <span class="type_icon_bg">
            <i class="fa fa-flag-o" aria-hidden="true"></i>
          </span>
          &nbsp; Milestones
        </span>
        <span class="scheduler_type" :class="{ active_item: scheduler.scheduleType === 'custom' }" v-on:click="changeType('custom')">
          <span class="type_icon_bg">
            <i class="fa fa-sliders" aria-hidden="true"></i>
          </span>
          &nbsp; Custom frequency
        </span>
      </div>
      <div class="pt-40" v-if="scheduler.scheduleType === 'milestone'">
        <div v-if="studyData.milestones && studyData.milestones.length > 0">
          <div class="scheduler-heading pb-5">
            Which milestones will you complete this activity for?
            <span class="edit_milestone_link p-0" v-on:click="updateMilestones()">Edit milestones</span>
          </div>
          <div v-if="studyData.screeningMilestoneAllowed">
            <div
              :class="{
                selected_milestone: scheduler.milestones && scheduler.milestones.indexOf(milestone.milestoneDay) >= 0
              }"
              class="milestone_card"
              :key="index"
              v-for="(milestone, index) in screeningMilestones"
            >
              <div v-if="scheduler.milestones && milestone.isDoNotShowTimeline" class="notShownCSS" :class="[scheduler.milestones && scheduler.milestones.indexOf(milestone.milestoneDay) < 0 ? '' : 'selectedNotShownCSS']">
                Not shown
              </div>
              <div class="day_card" v-on:click="selectUnselectMileStone(milestone.milestoneDay)">
                <p class="m-0">{{ milestone.displayName }}</p>
                <p class="m-0 day_text">Day {{ milestone.milestoneDay }}</p>
                <i v-if="scheduler.milestones && scheduler.milestones.indexOf(milestone.milestoneDay) >= 0" class="fa fa-check-circle" aria-hidden="true"></i>
                <div class="day_text  position-relative" v-if="milestone.segments && milestone.segments.length > 0">
                  <span class="cursor_pointer CohortDIV dropdown-toggle">{{ milestone.segments.length }} Cohorts</span>
                  <div class="dropdown-menu cohortDrop Cohort_hide" disabled aria-labelledby="dropdownMenuLink">
                    <div class="dropdown-item" href="#">
                      <span class="d-block" v-for="cohort in milestone.segments" :key="cohort"> {{ getSegmentName(cohort) }}</span>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <span>
                    All Participants
                  </span>
                </div>
              </div>
              <div class="completion-window  d-flex justify-content-between" v-if="scheduler && scheduler.milestones && scheduler.milestones.indexOf(milestone.milestoneDay) >= 0">
                <p class="">Completion Window</p>
                <input type="number" placeholder="1 day" v-model="scheduler.completionWindows[milestone.milestoneDay]" v-on:blur="setCompletionWindows(milestone, scheduler.completionWindows[milestone.milestoneDay])" />
              </div>
            </div>
          </div>
          <div
            :class="{
              selected_milestone: scheduler.milestones && scheduler.milestones.indexOf(milestone.milestoneDay) >= 0
            }"
            class="milestone_card"
            :key="index"
            v-for="(milestone, index) in regularMilestones"
          >
            <div v-if="scheduler.milestones && milestone.isDoNotShowTimeline" class="notShownCSS" :class="[scheduler.milestones && scheduler.milestones.indexOf(milestone.milestoneDay) < 0 ? '' : 'selectedNotShownCSS']">
              Not shown
            </div>
            <div class="day_card" v-on:click="selectUnselectMileStone(milestone.milestoneDay)">
              <p class="m-0">Milestone {{ index + 1 }}</p>
              <p class="m-0 day_text">Day {{ milestone.milestoneDay }}</p>
              <i v-if="scheduler && scheduler.milestones && scheduler.milestones.indexOf(milestone.milestoneDay) >= 0" class="fa fa-check-circle" aria-hidden="true"></i>
              <div class="day_text  position-relative" v-if="milestone.segments && milestone.segments.length > 0">
                <span class="cursor_pointer CohortDIV dropdown-toggle">{{ milestone.segments.length }} Cohorts</span>
                <div class="dropdown-menu cohortDrop Cohort_hide" disabled aria-labelledby="dropdownMenuLink">
                  <div class="dropdown-item" href="#">
                    <span class="d-block" v-for="cohort in milestone.segments" :key="cohort"> {{ getSegmentName(cohort) }}</span>
                  </div>
                </div>
              </div>
              <div v-else>
                <span>
                  All Participants
                </span>
              </div>
            </div>
            <div class="completion-window  d-flex justify-content-between" v-if="scheduler && scheduler.milestones && scheduler.milestones.indexOf(milestone.milestoneDay) >= 0">
              <p class="">Completion Window</p>
              <input type="number" placeholder="1 day" v-model="scheduler.completionWindows[milestone.milestoneDay]" v-on:blur="setCompletionWindows(milestone, scheduler.completionWindows[milestone.milestoneDay])" />
            </div>
          </div>
          <div v-if="options.validateFor !== 'telehealth' && options.validateFor !== 'notification'">
            <label class="fw-normal">
              <input type="checkbox" name="allowMultiReponseInCompletionWindow" v-model="scheduler.allowMultiReponseInCompletionWindow" class="checkbox_position" @change="updateShowDailySummary()" />
              <span class="">
                Allow participants to repeat
                <span v-if="options.validateFor === 'Survey'">survey</span>
                <span v-else>activity</span> each time it is present</span
              >
            </label>
            <label
              class="fw-normal"
              :class="{
                'opacity-change': !scheduler.allowMultiReponseInCompletionWindow
              }"
            >
              <input type="checkbox" name="showDailySummary" v-model="scheduler.showDailySummary" class="checkbox_position" :disabled="!scheduler.allowMultiReponseInCompletionWindow" />
              <span> Show participants a summary of their daily activity completion at the start of the activity. Available only for repeatable tasks.</span>
            </label>
            <div
              class="view-screen"
              :class="{
                'opacity-change': !scheduler.allowMultiReponseInCompletionWindow
              }"
            >
              <span v-if="scheduler.allowMultiReponseInCompletionWindow" data-toggle="modal" data-target="#screen-modal" class="cursor_pointer">View Daily Activity Completion Screen</span>
              <span v-else>View Daily Activity Completion Screen</span>
            </div>
            <div id="screen-modal" class="modal fade modal-position" role="dialog">
              <div class="modal-dialog">
                <!-- Modal content-->
                <div class="modal-content">
                  <img alt="Repeatable Activity" src="static/img/repeatable-activity-example.png" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!studyData.milestones || studyData.milestones.length == 0">
          <button type="button" class="btn btn-md btn-block create_milestone_btn br-25" v-on:click="updateMilestones()">
            Create milestones
          </button>
        </div>
      </div>
      <div class="pt-40" v-if="scheduler.scheduleType === 'custom'">
        <div v-if="studyData && studyData.isSegmentSupported">
          <div class="pb-5 scheduler-heading">
            Which cohort(s) would you like to schedule to ?
          </div>
          <div class="milestone_card" :class="{ selected_milestone: segmentId == null }" v-on:click="selectUnselectSegments(null)">
            <span>
              All Participants
            </span>
          </div>
          <div
            :class="{
              selected_milestone: segmentId && cohort.id === segmentId
            }"
            class="milestone_card"
            v-for="cohort in studyData.segments"
            :key="cohort.id"
            v-on:click="selectUnselectSegments(cohort.id)"
          >
            <p class="m-0 pt-5">{{ cohort.name }}</p>
          </div>
        </div>
        <div class="pb-5 scheduler-heading">
          What frequency will your partcipants take this activity?
        </div>
        <div
          :class="{
            selected_milestone: scheduler.frequency && scheduler.frequency.type && f.type === scheduler.frequency.type,
            disabled_frequency: f.disabled
          }"
          class="milestone_card"
          :key="index"
          v-for="(f, index) in frequencies"
          v-on:click="selectUnselectFrequency(f)"
        >
          <p class="m-0 pt-5">{{ f.title }}</p>
          <i v-if="scheduler.frequency && scheduler.frequency.type && f.type === scheduler.frequency.type" class="fa fa-info-circle p-1" aria-hidden="true"></i>
        </div>
        <div v-if="options.validateFor !== 'telehealth' && options.validateFor !== 'notification'">
          <label class="fw-normal">
            <input type="checkbox" name="allowMultiReponseInCompletionWindow" v-model="scheduler.allowMultiReponseInCompletionWindow" class="checkbox_position" @change="updateShowDailySummary()" />
            <span class="">
              Allow participants to repeat
              <span v-if="options.validateFor === 'Survey'">survey</span><span v-else>activity</span> each time it is present</span
            >
          </label>
          <label
            class="fw-normal"
            :class="{
              'opacity-change': !scheduler.allowMultiReponseInCompletionWindow
            }"
          >
            <input type="checkbox" name="showDailySummary" v-model="scheduler.showDailySummary" class="checkbox_position" :disabled="!scheduler.allowMultiReponseInCompletionWindow" />
            <span> Show participants a summary of their daily activity completion at the start of the activity. Available only for repeatable tasks.</span>
          </label>
          <div
            class="view-screen"
            :class="{
              'opacity-change': !scheduler.allowMultiReponseInCompletionWindow
            }"
          >
            <span v-if="scheduler.allowMultiReponseInCompletionWindow" data-toggle="modal" data-target="#screen-modal" class="cursor_pointer">View Daily Activity Completion Screen</span>
            <span v-else>View Daily Activity Completion Screen</span>
          </div>
        </div>
        <div id="screen-modal" class="modal fade modal-position" role="dialog">
          <div class="modal-dialog">
            <!-- Modal content-->
            <div class="modal-content">
              <img alt="Repeatable Activity" src="static/img/repeatable-activity-example.png" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4 p-0" v-if="options.validateFor !== 'notification'">
            <div class="pt-40">
              <div class="scheduler-heading">
                What is the completion window?
                <a class="color_grey cursor_pointer" data-toggle="modal" data-target="#completionModal">
                  <i class="fa fa-info-circle p-1"></i>
                </a>
              </div>
              <input type="number" min="1" class="form-control completion_window_days input-color" placeholder="Enter" v-model="scheduler.completionDuration" />
              days
            </div>
          </div>
        </div>
        <div class="pt-40">
          <div class="scheduler-heading">
            Select time period this survey should appear
            <span class="study_duration">Study ends on day {{ studyDuration }}</span>
          </div>
          <div class="pb-15" v-for="(item, index) in scheduler.duration" :key="index">
            <div class="row fs-12 color_959fa4">
              <div class="col-md-2 pl-0">Start</div>
              <div class="col-md-6 pl-0">End</div>
            </div>
            <div class="row">
              <div class="col-md-1 pl-0 pr-0">
                <span class="day_label">Day</span>
              </div>
              <div class="col-md-1 pl-0">
                <input type="number" v-validate="'required|min_value:1'" name="startDay" class="form-control" v-model="item.startDay" @input="isNumber()" />
              </div>
              <div class="col-md-1 pl-0 pr-0">
                <span class="day_label">Day</span>
              </div>
              <div class="col-md-1 pl-0">
                <input type="number" class="form-control" v-validate="'required|min_value:1'" name="endDay" v-model="item.endDay" :disabled="scheduler.allowUntillDuration && index + 1 === scheduler.duration.length" @input="isNumber()" />
              </div>
              <div class="col-md-2 pl-0 color_blue cursor_pointer pt-5" v-on:click="addAnotherDuration(index)" v-if="scheduler.duration.length === index + 1 && !scheduler.allowUntillDuration">
                Add another time period
              </div>
              <div class="col-md-2 pl-0 color_red cursor_pointer pt-5" v-on:click="removeDuration(index)" v-if="scheduler.duration.length !== index + 1">
                Remove
              </div>
            </div>
          </div>
          <div class="pt-10">
            <label class="fw-normal">
              <input type="checkbox" class="checkbox_position" name="allowUntillDuration" v-model="scheduler.allowUntillDuration" v-on:change="allowUntilDurationChanges(scheduler.allowUntillDuration)" />
              <span class=""> Available until the end of participant's study duration</span>
            </label>
          </div>
        </div>
      </div>
      <div class="pt-10">
        <!-- Dynamic scheduling section starts -->

        <dynamic-scheduling-section v-if="isForm() && activityData" :activityMode="activitySchedulingMode" :studyData="studyDataForDynamicScheduling" :taskDetails="activityData" :schedulerDetails="getSchedularDetails" />

        <!-- Dynamic scheduling section ends -->
      </div>
      <div id="completionModal" class="modal fade" role="dialog">
        <div class="modal-dialog">
          <!-- Modal content-->
          <div class="modal-content">
            <div>
              <div class="row text-right">
                <a class="cancelImage cursor_pointer" data-dismiss="modal">
                  <i class="fa fa-times" aria-hidden="true"></i>
                </a>
              </div>
              <div class="example">
                <p class="example-header">
                  When a task is assigned to the participant, you have the opportunity to set the window of completion for the task before it expires.
                </p>
                <div class="bg-milestone pb-40">
                  <p class="example-content text-center">
                    Example: A survey is assigned to a participant at study week 2, which for this participant happens to be a Wednesday, and a 3 day completion window has been set. The survey will be pushed to the participant on Wednesday and will be available through Friday. On Saturday morning, the survey will be removed from participant’s task list and will be reported as a missed task.
                  </p>
                  <div class="row milestone">
                    <div class="col-lg-2 ml-0 pl-0 mr-0 pr-0" v-for="(milestone, index) in exampleMileStone" :key="index">
                      <div class="text-center">{{ milestone.day }}</div>
                      <div class="milestone_box" :class="{ 'white-bg': milestone.day === 'Sat' }">
                        <div
                          class="circle"
                          v-if="milestone.class"
                          :class="{
                            'bg-green': milestone.day === 'Wed',
                            'bg-red': milestone.day === 'Sat'
                          }"
                        ></div>
                      </div>
                      <div class="text-center">{{ milestone.date }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import toastr from "toastr";
import _ from "lodash";
import moment from "moment";
import { mapGetters } from "vuex";
import { TRIGGER_NAME, ACTION_NAME, SCHEDULINGS_NAME } from "@/constants/dynamicSchedulingConstants";
import DynamicSchedulingSection from "../common/dynamic-scheduling-components-collection/dynamic-scheduling-section";

const MODE = {
  schedule: "schedule",
  both: "both",
  onDemand: "onDemand",
  dynamicOnly: "dynamicOnly"
};
const MODE_ICON = {
  schedule: {
    selected: "static/img/selected-scheduled-activity-icon.svg",
    unselected: "static/img/scheduled-activity-icon.svg"
  },
  both: {
    selected: "static/img/selected-scheduled-and-on-demand-activity.svg",
    unselected: "static/img/scheduled-and-on-demand-activity.svg"
  },
  onDemand: {
    selected: "static/img/selected-on-demand-activity-icon.svg",
    unselected: "static/img/on-demand-activity-icon.svg"
  },
  dynamicOnly: {
    selected: "static/img/dynamic-only-white-icon.svg",
    unselected: "static/img/dynamic-only-white-icon.svg"
  }
};

export default {
  name: "activity-scheduler",
  data() {
    return {
      studyId: null,
      formId: null,
      phoneNumberEnable: false,
      studyData: {},
      studyDuration: null,
      taskId: null,
      segmentId: null,
      finalMilestoneCount: [],
      getApiSchedular: null,
      getApiCohortSchedular: null,
      isMilestoneNotification: false,
      formData: {},
      milestones: [],
      frequencies: [
        { type: "daily", title: "Daily", days: 1, disabled: false },
        { type: "weekly", title: "Weekly", days: 7, disabled: false },
        { type: "biweekly", title: "Every 2 Weeks", days: 14, disabled: false },
        { type: "monthly", title: "Monthly", days: 30, disabled: false },
        {
          type: "biannually",
          title: "Bi-annually",
          days: 182,
          disabled: false
        },
        { type: "annually", title: "Annually", days: 365, disabled: false }
      ],
      scheduler: {
        scheduleType: "milestone",
        milestones: [],
        frequency: { type: null, title: null, days: null },
        startDay: null,
        endDay: null,
        completionDuration: null,
        completionWindows: {},
        allowMultiReponseInCompletionWindow: false,
        allowUntillDuration: false,
        showDailySummary: false,
        duration: [{ startDay: null, endDay: null }],
        activitySchedulingMode: "schedule",
        dynamicScheduling: null
      },
      defaultSchedulerObj: {
        scheduleType: "milestone",
        milestones: [],
        frequency: { type: null, title: null, days: null },
        startDay: null,
        endDay: null,
        completionWindows: {},
        completionDuration: null,
        allowMultiReponseInCompletionWindow: false,
        allowUntillDuration: false,
        showDailySummary: false,
        duration: [{ startDay: null, endDay: null }],
        activitySchedulingMode: "schedule"
      },
      activityDataIsLoaded: false,
      exampleMileStone: [
        { date: "Day1", day: "Wed", class: "bg-green" },
        { date: "Day2", day: "Thur", class: "" },
        { date: "Day3", day: "Fri", class: "" },
        { date: "+2", day: "Sat", class: "bg-red" }
      ],
      time: {
        hh: "",
        mm: "",
        A: ""
      },
      screenCountCheck: [],
      activitySchedulingMode: "schedule",
      activityModeIcon: {
        schedule: MODE_ICON.schedule.unselected,
        both: MODE_ICON.both.unselected,
        onDemand: MODE_ICON.onDemand.unselected,
        dynamicOnly: MODE_ICON.dynamicOnly.unselected
      },
      formRevisionId: null,
      activityData: null,
      studyDataForDynamicScheduling: null,
      activityScheduler: null,
      dynamicScheduleActivityAssociation: [],
      checkCount: 0,
      savedScheduler: null
    };
  },
  components: {
    DynamicSchedulingSection
  },
  props: ["options"],
  computed: {
    ...mapGetters(["getDynamicActivitySchedules", "getConstantDynamicActivitySchedulesData"]),
    schedulerObjChanged() {
      return this.$store.getters.getSchedulerObjData;
    },
    regularMilestones() {
      if (this.studyData.milestonesList) {
        if (this.studyData.screeningMilestoneAllowed && this.studyData.screeningDuration) {
          const filtered = this.studyData.milestonesList.filter(mile => mile.milestoneType != "screening");
          filtered.forEach(mile => {
            mile.milestoneDay -= this.studyData.screeningDuration;
          });
          return filtered;
        } else {
          return this.studyData.milestonesList;
        }
      }
      return [];
    },
    screeningMilestones() {
      if (this.studyData.milestonesList) {
        const filtered = this.studyData.milestonesList.filter(mile => mile.milestoneType == "screening");
        filtered.forEach(mile => {
          mile.milestoneDay -= this.studyData.screeningDuration;
        });
        return filtered;
      }
      return [];
    },
    showDynamicOnly() {
      if (this.activityData && this.isForm()) {
        if (!this.scheduler) {
          return true;
        } else if (this.scheduler && this.scheduler.activitySchedulingMode !== "onDemand") {
          return true;
        } else if (this.scheduler && this.scheduler.activitySchedulingMode === "onDemand" && this.activitySchedulingMode != "onDemand") {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    getSchedularDetails() {
      if (this.activityScheduler && this.activityScheduler.tasks && this.activityScheduler.tasks[0]) {
        return this.activityScheduler.tasks[0];
      }
      // When this activity is in unscheduled state
      else {
        return null;
      }
    }
  },
  mounted() {
    this.studyId = this.$route.params.studyId;
    this.formId = this.$route.params.formId;
    this.formRevisionId = this.$route.query && this.$route.query.revisionId;
    this.getStudyDetails();
    if (this.formId && this.formRevisionId) {
      this.getActivityData(this.formId, this.formRevisionId);
    }
  },
  watch: {
    schedulerObjChanged: {
      handler(val) {
        if (val.validateFor) {
          this.checkValidation(this.scheduler);
        }
      }
    },
    scheduler: {
      deep: true,
      handler() {
        this.$emit("input", this.scheduler);
        this.allowUntilDurationChanges(this.scheduler.allowUntillDuration);
      }
    },
    activitySchedulingMode: {
      handler(val) {
        if (val !== null) {
          if (this.activityDataIsLoaded) {
            this.getDefaultValue(this.scheduler, this);
          }
        }
      }
    },
    studyData: {
      deep: true,
      handler() {
        this.getActivityDetails();
      }
    }
  },
  methods: {
    changeActivityMode(mode) {
      this.activitySchedulingMode = mode;
      this.setActivityModeIcon(mode);
    },
    setActivityModeIcon(mode) {
      for (const prop in this.activityModeIcon) {
        if (prop === mode) {
          this.activityModeIcon[prop] = MODE_ICON[prop]["selected"];
        } else {
          this.activityModeIcon[prop] = MODE_ICON[prop]["unselected"];
        }
      }
    },
    changeType(type) {
      this.scheduler.scheduleType = type;
    },
    isNumber() {
      this.scheduler.duration.filter(rec => {
        if (rec.startDay) {
          if (rec.startDay % 1 !== 0 || rec.startDay < 0) {
            rec.startDay = parseInt(rec.startDay);
          }
          rec.startDay = parseInt(rec.startDay);
        }
        if (rec.endDay) {
          if (rec.endDay % 1 !== 0 || rec.endDay < 0) {
            rec.endDay = parseInt(rec.endDay);
          }
          rec.endDay = parseInt(rec.endDay);
        }
      });
    },
    validateMilestoneType(possibleVal, valid, scheduler, mArr, milestones) {
      let validScheduler = valid;
      let minDiff = null;
      if (possibleVal && validScheduler && (scheduler.advanceScheduleDays === null || scheduler.advanceScheduleDays === undefined || scheduler.advanceScheduleDays < 0 || scheduler.advanceScheduleDays % 1 !== 0)) {
        validScheduler = false;
        toastr.error(scheduler.advanceScheduleDays ? "Advance days cannot have decimals" : "Please enter advance days");
      }
      if (mArr.length !== 0) {
        // when multiple milestones are selected
        const milestoneArr = _.sortBy(mArr);
        const diffArr = [];
        for (let i = 1; i < milestoneArr.length; i++) {
          diffArr[i - 1] = milestoneArr[i] - (milestoneArr[i - 1] + scheduler.completionDuration);
        }
        minDiff = _.min(diffArr);
      } else {
        // when one milestone is selected
        minDiff = milestones[0] !== 0 ? milestones[0] - 1 : 0;
      }
      if (scheduler.milestones.length === 1) {
        minDiff = scheduler.milestones[0];
      }
      if (scheduler.advanceScheduleDays > minDiff) {
        if (minDiff !== 0) {
          toastr.error(`Number of advanced days can be between 0 and ${minDiff}`);
        } else if (minDiff === 0) {
          toastr.error("Number of advanced days can be 0 only");
        }
      }
      return scheduler.advanceScheduleDays <= minDiff && validScheduler;
    },
    findBetweenValue(a, b, c) {
      let max, min;
      if (this.studyData.screeningMilestoneAllowed) {
        min = Math.min(Math, [a - this.studyData.screeningDuration, b - this.studyData.screeningDuration]);

        max = Math.max(Math, [a - this.studyData.screeningDuration, b - this.studyData.screeningDuration]);
      } else {
        min = Math.min(Math, [a, b]);

        max = Math.max(Math, [a, b]);
      }

      return c >= min && c <= max;
    },
    isDateOfBirth(key) {
      return key === "dob" || key === "birthDate" || key === "dobWithMonthYear" || key === "dobWithYear";
    },
    checkValidation(originalScheduler) {
      const scheduler = { ...originalScheduler };

      /* Only for 'Dynamic Only' activities - Start; this code will dis-allow a change in activity type from 'Dynamic Only' activities. */
      if (this.scheduler && this.activityScheduler && this.activityScheduler.activitySchedulingMode === MODE.dynamicOnly && this.activityScheduler.activitySchedulingMode !== this.activitySchedulingMode) {
        if (this.dynamicScheduleActivityAssociation.length) {
          const associatedActivityNames = this.convertArrayToText(this.dynamicScheduleActivityAssociation);
          toastr.error(`The scheduling method for this activity cannot be changed because it is already associated with a Dynamic Scheduling record that includes ${associatedActivityNames}.`);
          return;
        }
      }
      /* Only for 'Dynamic Only' activities - End */

      /* Logic to save dynamic-schedules in activity scheduling - Starts */
      scheduler["dynamicScheduling"] = this.getDynamicActivitySchedules;
      if (scheduler["dynamicScheduling"] && scheduler["dynamicScheduling"].length) {
        for (let i = 0; i < scheduler["dynamicScheduling"].length; i++) {
          if (scheduler["dynamicScheduling"][i]["scheduling"][0].type === SCHEDULINGS_NAME.MILESTONE || scheduler["dynamicScheduling"][i]["scheduling"][0].type === SCHEDULINGS_NAME.CUSTOM) {
            scheduler["dynamicScheduling"][i]["scheduling"][0]["allowUntillDuration"] = scheduler["allowUntillDuration"];
            scheduler["dynamicScheduling"][i]["scheduling"][0]["showDailySummary"] = scheduler["showDailySummary"];
            scheduler["dynamicScheduling"][i]["scheduling"][0]["sequence"] = i + 1;
          }
          for (const condt of scheduler["dynamicScheduling"][i]["conditions"]) {
            if (condt["trigger"] === TRIGGER_NAME.PARTICIPANT && this.isDateOfBirth(condt.field)) {
              condt["field"] = condt.field === "dob" || condt.field === "birthDate" ? "dob" : condt.field;
              // For dates in DD/MM/YYYY; no conversion required, but for dates in 'DD MM YYYY'; needs conversion to DD/MM/YYYY. PS- dates are never null here.
              condt["value"] = condt["value"].indexOf("/") > -1 ? condt["value"] : moment(condt["value"], "DD MMM YYYY").format("DD/MM/YYYY");
            }
          }
        }
        scheduler["dynamicScheduling"] = this.checkIfAnyDynamicSchedulesChanged(this.getConstantDynamicActivitySchedulesData, scheduler["dynamicScheduling"]);
        this.scheduler.dynamicScheduling = scheduler["dynamicScheduling"];
      }
      /* Logic to save dynamic-schedules in activity scheduling - Ends */

      scheduler.taskId = this.formId ? this.formId : "";
      scheduler.taskType = this.options.validateFor;
      scheduler.activitySchedulingMode = this.activitySchedulingMode;
      // When activity is scheduled for "onDemand" OR "dyaamicOnly"
      if (this.activitySchedulingMode === MODE.onDemand || this.activitySchedulingMode === MODE.dynamicOnly) {
        this.$store.dispatch("addSchedule", {
          validatedFor: this.options.validateFor,
          schedulerObj: scheduler
        });
        return;
      }
      let milestoneArr = [];
      let minDiff = null;
      let possibleVal = null;
      let validScheduler = true;
      let allDaysList = null;
      let properList = null;
      let durationValues = null;
      scheduler.completionDuration = scheduler.completionDuration ? Number(scheduler.completionDuration) : null;
      switch (scheduler.scheduleType) {
        case "milestone":
          if (scheduler.taskType !== "notification") {
            if (this.studyData.milestonesList && this.studyData.screeningMilestoneAllowed) {
              const list = this.studyData.milestonesList.filter(mile => mile.milestoneType == "screening");
              const duration = this.studyData.screeningDuration;
              if (this.validateMilestones(list, duration, "screening") !== true) {
                return;
              }
            }
            const list = this.studyData.milestonesList.filter(mile => mile.milestoneType != "screening");
            const duration = this.studyData.studyDuration;
            if (this.validateMilestones(list, duration, "") !== true) {
              return;
            }
            if (this.studyData.screeningMilestoneAllowed && this.studyData.screeningDuration) {
              this.filterSchedulerMilestonesForSaving(scheduler.milestones);
            }
            if (scheduler.milestones && scheduler.milestones.length > 0) {
              let milestonesData = "";
              scheduler.milestones.forEach(schedulerData => {
                milestonesData = schedulerData;
                this.studyData.milestones.forEach(studymilestones => {
                  if (studymilestones == milestonesData) {
                    this.finalMilestoneCount.push(studymilestones);
                  }
                });
              });
            }
            if (!scheduler.milestones || scheduler.milestones.length <= 0 || this.finalMilestoneCount.length == 0) {
              toastr.error("Please select a milestone");
              validScheduler = false;
            } else if (scheduler.milestones.length === 1) {
              possibleVal = this.studyDuration - scheduler.milestones[0] - 1;
              possibleVal = possibleVal === 0 ? 1 : possibleVal;
              if (scheduler.taskType === "truclinic" && scheduler.advanceScheduleDays > 99) {
                validScheduler = false;
                toastr.error("Advanced days cannot be more than 99");
              }
            } else {
              milestoneArr = _.map(scheduler.milestones, _.ary(parseInt, 1));
              milestoneArr.sort();
              minDiff = this.findMinDiff(milestoneArr);
              possibleVal = minDiff;
              possibleVal = possibleVal === 0 ? 1 : possibleVal;
            }
          } else if (scheduler.milestones.length <= 0) {
            // for notifications only
            toastr.error("Please select a milestone");
            validScheduler = false;
          }
          if (this.studyData.milestonesList) {
            this.scheduler.milestones.sort((a, b) => a - b);
          }
          if (validScheduler && scheduler.taskType === "truclinic" && !this.validateMilestoneType(possibleVal, validScheduler, scheduler, milestoneArr, scheduler.milestones)) {
            validScheduler = false;
          }
          if (validScheduler) {
            this.$store.dispatch("addSchedule", {
              validatedFor: this.options.validateFor,
              schedulerObj: scheduler
            });
          }
          break;
        case "custom":
          this.$validator.validateAll().then(valid => {
            scheduler.frequency = scheduler.frequency ? scheduler.frequency : { type: null, title: null, days: null, segmentId: null };
            durationValues = _.map(scheduler.duration, item => ({
              startDay: parseFloat(item.startDay),
              endDay: parseFloat(item.endDay)
            }));
            allDaysList = _.flatten(_.map(durationValues, o => [o.startDay, o.endDay]));
            properList = _.compact(allDaysList);
            properList = scheduler.allowUntillDuration && properList % 2 === 0 ? _.dropRight(properList) : properList;
            if (!scheduler.frequency.type || !scheduler.completionDuration) {
              toastr.error(!scheduler.frequency.type ? "Please select a frequency" : "Please specify completion window");
            } else if (scheduler.completionDuration <= 0 || scheduler.completionDuration % 1 !== 0) {
              toastr.error("Completion window should be greater than 0 and cannot have decimals");
            } else if (scheduler.completionDuration > scheduler.frequency.days) {
              toastr.error("Completion window cannot exceed the length of the frequency");
            } else if (!scheduler.allowUntillDuration && allDaysList.length !== properList.length && !scheduler.allowUntillDuration && allDaysList.length !== properList.length - 1 && !this.studyData.screeningMilestoneAllowed) {
              toastr.error("Start and End days should be greater than 0 and cannot have decimals");
            } else if (this.studyData.screeningMilestoneAllowed && _.min(properList) < -this.studyData.screeningDuration) {
              toastr.error("Start Day cannot be less than screening Duration");
            } else if (this.studyData.screeningMilestoneAllowed && durationValues[0].startDay < -this.studyData.screeningDuration && scheduler.allowUntillDuration) {
              toastr.error("Start Day cannot be less than screening Duration");
            } else if (this.errors.any() && !valid && !this.studyData.screeningMilestoneAllowed) {
              toastr.error("Start/End day should be greater than 0 and cannot have decimals");
            } else if (!this.isSorted(properList)) {
              toastr.error("Start and end days should be in increasing order.");
            } else if (!this.isValidDay(allDaysList)) {
              toastr.error("End day should be greater than start day.");
            } else if (_.uniq(properList).length !== properList.length) {
              toastr.error("Scheduled start and end days overlap. Please revise.");
            } else if (_.max(properList) > this.studyDuration) {
              toastr.error("Start and end day should be less than study duration");
            } else if (scheduler.taskType === "truclinic" && (scheduler.advanceScheduleDays === null || scheduler.advanceScheduleDays === undefined)) {
              toastr.error("Please enter value for advance days");
            } else if (scheduler.taskType === "truclinic" && !this.validateCustomType(scheduler, properList)) {
              toastr.error("Invalid values");
            } else if (this.isNumber()) {
              toastr.error("Please do not enter a decimal value for start day and end day");
            } else if (!scheduler.frequency.segmentId && !scheduler.frequency.segmentId == null) {
              toastr.error("Please select a cohort.");
            } else {
              let checkStartDay = false;
              let checkEndtDay = false;

              if (this.getApiSchedular && this.getApiSchedular.duration && this.getApiSchedular.duration.length && !!this.segmentId && this.studyData.isSegmentSupported) {
                this.getApiSchedular.duration.forEach(first => {
                  scheduler.duration.forEach(second => {
                    checkStartDay = this.findBetweenValue(first.startDay, first.endDay, second.startDay);
                    checkEndtDay = this.findBetweenValue(first.startDay, first.endDay, second.endDay);
                  });
                });
              } else if (!this.segmentId && this.studyData.isSegmentSupported && this.getApiCohortSchedular) {
                this.getApiCohortSchedular.forEach(data => {
                  data.duration.forEach(first => {
                    scheduler.duration.forEach(second => {
                      checkStartDay = this.findBetweenValue(first.startDay, first.endDay, second.startDay);
                      checkEndtDay = this.findBetweenValue(first.startDay, first.endDay, second.endDay);
                    });
                  });
                });
              }
              if (checkStartDay || checkEndtDay) {
                return toastr.error("Specified completion window overlaps with another cohort.");
              }
              if (this.studyData.screeningMilestoneAllowed) {
                for (let day = 0; day < durationValues.length; day++) {
                  if (durationValues[day].startDay === null || durationValues[day].startDay === "" || isNaN(durationValues[day].startDay)) {
                    return toastr.error("Start and end days cannot be empty.");
                  } else if ((durationValues[day].startDay === null || durationValues[day].startDay === "") && (durationValues[day].endDay === null || durationValues[day].endDay === "") && !scheduler.allowUntillDuration) {
                    return toastr.error("Start and end days cannot be empty.");
                  } else if ((durationValues[day].startDay === null || durationValues[day].startDay === "") && scheduler.allowUntillDuration) {
                    return toastr.error("Start and end days cannot be empty.");
                  } else if (durationValues[day].startDay > durationValues[day].endDay && !scheduler.allowUntillDuration) {
                    return toastr.error("Start day should be greater than End day.");
                  } else if ((isNaN(durationValues[day].startDay) || isNaN(durationValues[day].endDay)) && !scheduler.allowUntillDuration) {
                    return toastr.error("Start and end days cannot be empty.");
                  } else if (durationValues[day].startDay === 0 && durationValues[day].endDay === 0 && !scheduler.allowUntillDuration) {
                    return toastr.error("Start and End days should be greater than 0 and cannot have decimals.");
                  } else if ((durationValues[day].endDay === null || durationValues[day].endDay === "") && !scheduler.allowUntillDuration) {
                    return toastr.error("Start and end days cannot be empty.");
                  }
                }
                let schedulerDurationCopy = [];
                schedulerDurationCopy = _.cloneDeep(scheduler.duration);
                schedulerDurationCopy.forEach(duration => {
                  if (!isNaN(duration.startDay) && (!isNaN(duration.endDay) || scheduler.allowUntillDuration)) {
                    Object.keys(duration).forEach(key => {
                      if (!isNaN(duration[key]) && duration[key] !== null) {
                        duration[key] += this.studyData.screeningDuration;
                      }
                    });
                  }
                });
                scheduler.duration = schedulerDurationCopy;
              }
              scheduler.segmentId = null;
              if (this.segmentId) {
                scheduler.segmentId = this.segmentId;
              }

              this.$store.dispatch("addSchedule", {
                validatedFor: this.options.validateFor,
                schedulerObj: scheduler
              });
            }
          });
          break;
        default:
          break;
      }
    },
    selectUnselectSegments(cohortId) {
      this.segmentId = cohortId;
      let index = -1;
      if (this.formData.segmentSchedules && this.formData.segmentSchedules.length) {
        index = this.formData.segmentSchedules.findIndex(data => {
          return data.segmentId == cohortId;
        });
      }
      if (index > -1) {
        this.scheduler = Object.assign({}, this.getApiCohortSchedular[index]);
        this.scheduler.milestones = this.savedScheduler.milestones;
        this.scheduler.completionWindows = Object.assign({}, this.savedScheduler.completionWindows);
        const cohortExistCheck = this.screenCountCheck.findIndex(data => {
          return data.segmentId == cohortId;
        });
        if (cohortExistCheck == -1 && this.studyData.screeningMilestoneAllowed) {
          if (this.scheduler.duration && this.scheduler.duration.length) {
            this.scheduler.duration.forEach(duration => {
              if (duration.startDay != null && duration.endDay != null && !this.scheduler.allowUntillDuration) {
                Object.keys(duration).forEach(key => {
                  duration[key] -= this.studyData.screeningDuration;
                });
              } else if (duration.startDay != null && this.scheduler.allowUntillDuration) {
                Object.keys(duration).forEach(key => {
                  if (!!duration[key] && duration[key] != this.studyDuration) {
                    duration[key] -= this.studyData.screeningDuration;
                  } else {
                    duration[key] = duration["endDay"];
                  }
                });
              }
            });
          }
          this.screenCountCheck.push(this.scheduler);
        }
      } else if (this.formData.schedules && this.formData.schedules.length && this.formData.schedules[0].scheduleType === "custom" && !cohortId) {
        this.scheduler = Object.assign({}, this.formData.schedules[0]);
        if (this.scheduler.duration && this.scheduler.duration.length > 0 && this.checkCount < 1) {
          this.scheduler.duration.forEach(duration => {
            if (duration.startDay != null && duration.endDay != null) {
              Object.keys(duration).forEach(key => {
                duration[key] -= this.studyData.screeningDuration;
              });
            }
          });
          this.checkCount++;
        }
      } else {
        this.scheduler.duration = [{ startDay: null, endDay: null }];
      }
    },
    getSegmentName(segmentId) {
      const selectedSegments = this.studyData.segments.find(field => {
        return field.id == segmentId;
      });
      return !!selectedSegments && selectedSegments !== 0 ? selectedSegments.name : "All Participants";
    },
    selectUnselectFrequency(frequency) {
      this.scheduler.frequency = frequency;
      this.$forceUpdate();
    },
    getActivityDetails() {
      if (this.options.type == "Form") {
        this.$api.getEDCMilestonesFact(this.studyId, this.formId).then(
          response => {
            this.getScheduleFormDetails(response.body);
          },
          error => {
            toastr.error(error.body ? error.body.message : "Error while getting the study details");
          }
        );
      } else {
        const packetId = this.$route.params.packetId;
        this.$api.getScheduleActivityPacketFact(this.studyId, packetId).then(
          response => {
            this.getScheduleFormDetails(response.body);
          },
          error => {
            toastr.error(error.body ? error.body.message : "Error while the scheduling the survey");
          }
        );
      }
    },
    filteredCompletionWindowsForDisplay(completionWindows) {
      let newCompletion = {};
 
      Object.keys(completionWindows).forEach(key => {
        let newKey = Number(key) - Number(this.studyData.screeningDuration);
        newCompletion[newKey] = Number(completionWindows[key]);
      });
 
      return newCompletion;
    },
    getScheduleFormDetails(formDetail) {
      let custom;
      this.formData = formDetail;
      this.scheduler = formDetail.schedules.length ? formDetail.schedules[0] : this.scheduler;
      this.activityScheduler = _.cloneDeep(this.scheduler);
      this.getActivityAssociationInDynamicSchedules();
      const useScheduler = formDetail.schedules.length ? formDetail.schedules[0] : this.defaultSchedulerObj;
      if (useScheduler.completionWindows && useScheduler.completionWindows != null && Object.keys(useScheduler.completionWindows).length !== 0) {
        this.isMilestoneNotification = true;
      }
      this.getDefaultValue(_.cloneDeep(useScheduler), this);
      this.activityDataIsLoaded = true;
      if (formDetail.segmentSchedules.length) {
        this.getApiCohortSchedular = _.cloneDeep(formDetail.segmentSchedules);
        if (formDetail.segmentSchedules && formDetail.segmentSchedules.length > 1) {
          const lastSegmentIndex = formDetail.segmentSchedules.length - 1;
          this.scheduler = formDetail.segmentSchedules[lastSegmentIndex];
          this.segmentId = formDetail.segmentSchedules[lastSegmentIndex].segmentId;
          custom = formDetail.segmentSchedules[lastSegmentIndex];
        } else {
          this.scheduler = formDetail.segmentSchedules[0];
          this.segmentId = formDetail.segmentSchedules[0].segmentId;
          custom = formDetail.segmentSchedules[0];
        }
      }
      if (formDetail.schedules.length) {
        this.getApiSchedular = _.cloneDeep(formDetail.schedules[0]);
        this.scheduler = Object.assign({}, formDetail.schedules[0]);
        if (!!custom && !this.getApiSchedular.duration) {
          this.scheduler.duration = custom.duration;
          this.scheduler.frequency = custom.frequency;
        } else if (!this.getApiSchedular.duration) {
          this.scheduler.duration = [{ startDay: null, endDay: null }];
        } else {
          this.segmentId = this.scheduler.segmentId;
        }
      }
      this.activitySchedulingMode = this.scheduler.activitySchedulingMode;
      if (this.studyData.screeningMilestoneAllowed && this.studyData.screeningDuration) {
        if (this.getApiSchedular && this.getApiSchedular.milestones && this.getApiSchedular.milestones.length) {
          this.scheduler.milestones = this.filterSchedulerMilestonesForDisplay(this.getApiSchedular.milestones);
          this.scheduler.completionWindows = this.filteredCompletionWindowsForDisplay(this.getApiSchedular.completionWindows);
        }

        if (this.scheduler.duration && this.scheduler.duration.length > 0) {
          this.scheduler.duration.forEach(duration => {
            if (duration.startDay != null && duration.endDay != null) {
              Object.keys(duration).forEach(key => {
                if (key == "endDay" && duration[key] == this.studyDuration) {
                  duration[key] = this.studyDuration;
                } else {
                  duration[key] -= this.studyData.screeningDuration;
                }
              });
            }
          });
        }
      }
      if (this.getApiSchedular && this.getApiSchedular.scheduleType === "custom") {
        this.checkCount++;
      }
      this.savedScheduler = _.cloneDeep(this.scheduler);
    },
    selectUnselectMileStone(milestone) {
      if (!this.scheduler.milestones) {
        this.scheduler.milestones = [];
      }
      if (!this.scheduler.completionWindows) {
        this.scheduler.completionWindows = {};
      }
      if (this.scheduler && this.scheduler.milestones && this.scheduler.milestones.indexOf(milestone) < 0) {
        this.scheduler.milestones.push(milestone);
      } else {
        this.scheduler.milestones.splice(this.scheduler.milestones.indexOf(milestone), 1);
        delete this.scheduler.completionWindows[milestone];
      }
      this.$forceUpdate();
    },
    allowUntilDurationChanges(allowUntillDuration) {
      if (allowUntillDuration) {
        this.scheduler.duration[this.scheduler.duration.length - 1].endDay = null;
      }
    },
    addAnotherDuration() {
      this.scheduler.duration.push({ startDay: null, endDay: null });
      this.$forceUpdate();
    },
    removeDuration(index) {
      this.scheduler.duration.splice(index, 1);
      this.$forceUpdate();
    },
    updateMilestones() {
      window.localStorage.setItem("designIndex", 13);
      this.$router.push({
        name: "study-design",
        params: { studyId: this.studyId }
      });
    },
    setCompletionWindows(milestone, completionWindow) {
      milestone.completionWindow = Number(completionWindow);
    },
    updateShowDailySummary() {
      if (!this.scheduler.allowMultiReponseInCompletionWindow) {
        this.scheduler.showDailySummary = false;
      }
    },
    getDefaultValue(scheduler, _this) {
      const selectedMode = this.activitySchedulingMode;
      if (selectedMode) {
        if (selectedMode === MODE.schedule || selectedMode === MODE.both) {
          // when either 'Scheduled' or 'Scheduled & On-demand' type button is selected
          let savedMode;
          if (_this.savedScheduler) {
            // if activity has saved scheduler | case: edit
            savedMode = _this.savedScheduler.activitySchedulingMode;
          } else {
            // if activity has no saved scheduler | case: add/edit
            savedMode = scheduler.activitySchedulingMode;
          }
          if (selectedMode !== savedMode) {
            _this.initialize("empty", _this.defaultSchedulerObj);
          } else {
            if (_this.savedScheduler) {
              // if activity has saved scheduler
              _this.initialize("fill", _this.savedScheduler);
            } else {
              // if activity has no saved scheduler
              _this.initialize("empty", _this.defaultSchedulerObj);
            }
          }
        } else {
          if (_this.formData && _this.formData.schedules && _this.formData.schedules.length) {
            // if activity has saved scheduler
            _this.scheduler = {
              taskId: _this.formData.schedules[0].tasks[0].taskID,
              taskType: _this.formData.schedules[0].tasks[0].taskType,
              activitySchedulingMode: selectedMode,
              taskTitle: _this.formData.schedules[0].tasks[0].taskTitle
            };
          } else {
            // if activity has no saved scheduler
            _this.scheduler = {
              taskId: null,
              taskType: null,
              activitySchedulingMode: selectedMode,
              taskTitle: null
            };
          }
        }
      }
    },
    initialize(type, scheduler) {
      const self = this;
      const isEmpty = type => {
        return type === "empty";
      };
      const isFill = type => {
        return type === "fill";
      };
      self.scheduler = scheduler && isFill(type) ? scheduler : _.cloneDeep(self.defaultSchedulerObj);
      self.scheduler.activitySchedulingMode = this.activitySchedulingMode;
      if ((!self.scheduler.duration || self.scheduler.duration.length === 0 || isEmpty(type)) && !this.savedScheduler) {
        self.scheduler.duration = [{ startDay: null, endDay: null }];
      }
    },
    getExactDayEpoch(day) {
      const newDay = new Date(day);
      return new Date(newDay.getFullYear(), newDay.getMonth(), newDay.getDate(), 0, 0, 0).getTime();
    },
    getStudyDetails() {
      this.$api.getStudyDataFact(this.studyId).then(
        response => {
          this.studyData = response.body;
          this.studyDataForDynamicScheduling = _.cloneDeep(response.body);
          const sd = new Date(this.studyData.firstPatientEnrollDate).valueOf();
          const ed = new Date(this.studyData.firstPatientLastDate).valueOf();
          this.studyDuration = parseInt((this.getExactDayEpoch(ed) - this.getExactDayEpoch(sd)) / 1000 / 86400, 10);
          _.forEach(this.frequencies, val => {
            switch (val.type) {
              case "daily":
                val.disabled = this.studyDuration < 1;
                break;
              case "weekly":
                val.disabled = this.studyDuration < 7;
                break;
              case "biweekly":
                val.disabled = this.studyDuration < 15;
                break;
              case "monthly":
                val.disabled = this.studyDuration < 30;
                break;
              case "biannually":
                val.disabled = this.studyDuration < 180;
                break;
              case "annually":
                val.disabled = this.studyDuration < 365;
                break;
              default:
                break;
            }
          });
        },
        error => {
          toastr.error(error.body ? error.body.message : "Error while getting the study details");
        }
      );
    },
    findMinDiff(val) {
      let s = val;
      let m, i, j;
      // eslint-disable-next-line no-eval
      s = eval(s);
      m = Math.abs(s[(i = 0)] - s[(j = 1)]);
      for (; i < s.length; i++) {
        j = i;
        for (++j; j < s.length; ++j) {
          const newV = Math.abs(s[i] - s[j]);
          m = newV < m ? newV : m;
        }
      }
      return m;
    },
    isSorted(arr) {
      const len = arr.length - 1;
      for (let i = 0; i < len; ++i) {
        if (arr[i] > arr[i + 1]) {
          return false;
        }
      }
      return true;
    },
    isValidDay(arr) {
      const len = arr.length - 1;
      for (let i = 0; i < len; ++i) {
        if (arr[i] > arr[i + 1]) {
          return false;
        }
        i = i + 2;
      }
      return true;
    },
    validateMilestones(list, duration, type) {
      const milestoneList = list;
      let filteredScheduler;
      const filteredCompletionWindow = _.cloneDeep(this.scheduler.completionWindows);

      if (type == "screening") {
        filteredScheduler = this.scheduler.milestones.filter(m => m < 0);
        Object.keys(filteredCompletionWindow).forEach(key => {
          if (key >= 0) {
            delete filteredCompletionWindow[key];
          }
        });
      } else {
        filteredScheduler = this.scheduler.milestones.filter(m => m >= 0);
        Object.keys(filteredCompletionWindow).forEach(key => {
          if (key < 0) {
            delete filteredCompletionWindow[key];
          }
        });
      }

      filteredScheduler.sort((a, b) => a - b);
      for (let i = 0; i < milestoneList.length; i++) {
        const milestoneDay = milestoneList[i].milestoneDay;
        let completionWindow = filteredCompletionWindow[milestoneDay];
        const selectedMilestoneIndex = filteredScheduler.indexOf(milestoneDay);

        const nextSelectedMilestoneDay = filteredScheduler[selectedMilestoneIndex + 1];
        completionWindow = Number(completionWindow);

        if (filteredScheduler.indexOf(milestoneDay) < 0) {
          continue;
        }
        if (!completionWindow) {
          toastr.error("Number of days for completion window is required.");
          return;
        } else if (completionWindow < 1) {
          toastr.error("Please specify completion window with value greater than 0.");
          return;
        } else if (completionWindow > duration) {
          if (type == "screening") {
            toastr.error(`Specified completion window cannot exceed ${type} duration.`);
          } else {
            toastr.error("Specified completion window cannot exceed study duration.");
          }
          return;
        } else if (!!nextSelectedMilestoneDay && milestoneDay + completionWindow > nextSelectedMilestoneDay) {
          toastr.error(`Specified completion window overlaps with another ${type} milestone.`);
          return;
        }
      }
      return true;
    },
    filterSchedulerMilestonesForSaving(milestones) {
      for (let i = 0; i < milestones.length; i++) {
        milestones[i] += this.studyData.screeningDuration;
      }
    },
    filterSchedulerMilestonesForDisplay(milestones) {
      const duration = this.studyData.screeningDuration;
      for (let i = 0; i < milestones.length; i++) {
        milestones[i] -= duration;
      }
      return milestones;
    },
    isForm() {
      /* To check if type of this activity is site facing Form. */
      return this.options && this.options.type && this.options.type.toUpperCase() === "FORM";
    },
    isPacket() {
      /* To check if type of this activity is packet. */
      return this.options && this.options.type && this.options.type.toUpperCase() === "PACKET";
    },
    getActivityData(activityId, revisionId) {
      this.$api.getActivityDetails(activityId, revisionId).then(
        response => {
          this.activityData = response.data.result;
        },
        error => {
          this.errorMsg = error.body ? error.body.message : "Error while getting activity details";
          toastr.error(this.errorMsg);
        }
      );
    },
    updateDynamicSchedulePropertyValue(value) {
      this.dynamicScheduleUpdated = value;
      return this.dynamicScheduleUpdated;
    },
    checkIfDynamicScheduleChanged(constantSchedule, changedSchedule) {
      let actions = null;

      let c_actions = null;

      let conditions = null;

      let c_conditions = null;

      let scheduling = null;

      let c_scheduling = null;

      let index = 0;

      actions = constantSchedule.actions;
      c_actions = changedSchedule.actions;

      conditions = constantSchedule.conditions;
      c_conditions = changedSchedule.conditions;

      scheduling = constantSchedule.scheduling[0];
      c_scheduling = changedSchedule.scheduling[0];

      if (actions.length != c_actions.length) {
        return this.updateDynamicSchedulePropertyValue(true);
      }

      index = 0;
      for (const a of actions) {
        if (a["type"] != c_actions[index]["type"]) {
          return this.updateDynamicSchedulePropertyValue(true);
        }

        if (a["type"] == ACTION_NAME.ADD_AN_ACTIVITY) {
          if (a["tasks"] && a["tasks"][0]["taskID"] != c_actions[index]["tasks"][0]["taskID"]) {
            return this.updateDynamicSchedulePropertyValue(true);
          }
        } else if (a["type"] == ACTION_NAME.REMOVE_AN_ACTIVITY) {
          if (a["tasks"] && a["tasks"][0]["taskID"] != c_actions[index]["tasks"][0]["taskID"]) {
            return this.updateDynamicSchedulePropertyValue(true);
          }
        } else if (a["type"] == ACTION_NAME.NOTIFY_SITE_TEAM_MEMBER) {
          if (a["role"] && JSON.stringify(a["role"]) != JSON.stringify(c_actions[index]["role"])) {
            return this.updateDynamicSchedulePropertyValue(true);
          }
        }
        index++;
      }

      if (conditions.length != c_conditions.length) {
        return this.updateDynamicSchedulePropertyValue(true);
      }

      index = 0;
      for (const c of conditions) {
        if (c["trigger"] != c_conditions[index]["trigger"]) {
          return this.updateDynamicSchedulePropertyValue(true);
        }

        if (c["trigger"] == TRIGGER_NAME.MILESTONE_COMPLETED) {
          if (c["milestones"] && JSON.stringify(c["milestones"]) != JSON.stringify(c_conditions[index]["milestones"])) {
            return this.updateDynamicSchedulePropertyValue(true);
          }
        } else if (c["trigger"] == TRIGGER_NAME.STEP_IN_ACTIVITY_COMPLETED) {
          if (c["responseOptionId"] != c_conditions[index]["responseOptionId"] || c["anyResponse"] != c_conditions[index]["anyResponse"] || c["noResponse"] != c_conditions[index]["noResponse"]) {
            return this.updateDynamicSchedulePropertyValue(true);
          }
        } else if (c["trigger"] == TRIGGER_NAME.PARTICIPANT) {
          if (c["field"] != c_conditions[index]["field"]) {
            return this.updateDynamicSchedulePropertyValue(true);
          }

          switch (c["field"]) {
            case "dob":
            case "dobWithMonthYear":
            case "dobWithYear":
              if (c["operator"] != c_conditions[index]["operator"] || c["value"] != c_conditions[index]["value"]) {
                return this.updateDynamicSchedulePropertyValue(true);
              }
              break;
            case "country":
              if (c["value"] != c_conditions[index]["value"]) {
                return this.updateDynamicSchedulePropertyValue(true);
              }
              break;
            case "gender":
              if (c["value"] != c_conditions[index]["value"]) {
                return this.updateDynamicSchedulePropertyValue(true);
              }
              break;
            case "language":
              if (c["operator"] != c_conditions[index]["operator"] || c["value"] != c_conditions[index]["value"]) {
                return this.updateDynamicSchedulePropertyValue(true);
              }
              break;
            case "ageRange":
              if (c["value"] != c_conditions[index]["value"]) {
                return this.updateDynamicSchedulePropertyValue(true);
              }
              break;
          }
        }
        index++;
      }

      if (scheduling["type"] != c_scheduling["type"]) {
        return this.updateDynamicSchedulePropertyValue(true);
      } else if (scheduling["type"] === SCHEDULINGS_NAME.MILESTONE) {
        if (JSON.stringify(scheduling["milestones"]) != JSON.stringify(c_scheduling["milestones"])) {
          return this.updateDynamicSchedulePropertyValue(true);
        }
      } else if (scheduling["type"] === SCHEDULINGS_NAME.NO_OF_DAYS) {
        if (scheduling["completionWindow"] != c_scheduling["completionWindow"] || scheduling["days"] != c_scheduling["days"]) {
          return this.updateDynamicSchedulePropertyValue(true);
        }
      } else if (scheduling["type"] === SCHEDULINGS_NAME.CUSTOM) {
        if (scheduling["frequency"]["type"] != c_scheduling["frequency"]["type"] || scheduling["completionWindow"] != c_scheduling["completionWindow"]) {
          return this.updateDynamicSchedulePropertyValue(true);
        }
      }

      return this.dynamicScheduleUpdated;
    },
    checkIfAnyDynamicSchedulesChanged(constantScheduleList, changedScheduleList) {
      for (let i = 0; i < changedScheduleList.length; i++) {
        this.dynamicScheduleUpdated = false;

        const changedSchedule = changedScheduleList[i];
        if (!changedSchedule.dynamicSchedulingId) {
          /* New Dynamic Schedule is added */
          changedScheduleList[i]["dynamicScheduleUpdated"] = true;
          continue;
        }
        const singleChangedScheduleObj = constantScheduleList.filter(obj => {
          return obj.dynamicSchedulingId === changedScheduleList[i].dynamicSchedulingId;
        });

        changedScheduleList[i]["dynamicScheduleUpdated"] = this.checkIfDynamicScheduleChanged(singleChangedScheduleObj[0], changedScheduleList[i]);
      }

      return changedScheduleList;
    },
    getActivityAssociationInDynamicSchedules() {
      if (this.activityScheduler && this.activityScheduler.activitySchedulingMode === MODE.dynamicOnly) {
        const params = {
          studyId: this.studyId,
          activityId: this.formId
        };
        this.$api.getActivityAssociationInDynamicSchedules(params).then(response => {
          this.dynamicScheduleActivityAssociation = response.body;
        });
      }
    },
    convertArrayToText(array) {
      /* Converts an array of strings to comma & 'and' separated String value. */
      let arrToStr = "";
      if (array.length === 1) {
        arrToStr = array[0];
      } else if (array.length === 2) {
        arrToStr = array[0] + " and " + array[1];
      } else {
        const lastElement = array.pop();
        arrToStr = array.join(", ") + " and " + lastElement;
      }
      return arrToStr;
    }
  }
};
</script>

<style scoped lang="scss">
.bg-green {
  background-color: #2ecc71 !important;
}

.bg-red {
  background-color: #ff7171 !important;
}
.scheduler-heading {
  font-weight: 600;
  color: #666769;
}

.container-style {
  border-radius: 2px;
  background-color: #ffffff;
  color: #666769;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
}
.error-style {
  font-size: 12px;
  color: #ff4848;
  padding-bottom: 5px;
}
.study_duration {
  display: inline-block;
  color: #4c8ce4;
  background-color: #edf3fc;
  padding: 2px 5px;
  border-radius: 2px;
}
.completion_window_days {
  width: 100px;
  display: inline-block;
}
.example {
  margin: 40px 40px 20px 40px;
}
.example-content {
  padding: 20px 40px 20px 40px;
}
.bg-milestone {
  background-color: #f5f8fa;
}
.example-header {
  padding: 20px 80px 10px 80px;
  font-weight: bold;
}

.milestone_box {
  border: 1px solid #34537d;
  width: 60px;
  height: 10px;
  padding-top: 1px;
  padding-bottom: 9px;
  border-radius: 100px;
  background-color: #34537d;
}
.disabled_frequency {
  pointer-events: none;
  background-color: #ddd !important;
}
.scheduler_types {
  margin-top: 8px;
  .scheduler_type {
    cursor: pointer;
    border: 1px solid #ccc;
    padding: 10px;
    margin-right: 10px;
    border-radius: 2px;
    min-height: 52px;
    display: inline-block;
    background-color: #fff;
  }
  .type_icon_bg {
    background-color: #ddd;
    width: 28px;
    height: 28px;
    display: inline-block;
    border-radius: 100%;
    padding: 3px;
    text-align: center;
  }
  .active_item {
    background-color: #32557a;
    color: #fff;
    .type_icon_bg {
      background-color: #488ee1;
    }
  }
}
.day_label {
  display: block;
  width: 100%;
  height: 34px;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1.42857143;
  color: #888;
  background-color: #fafafa;
  background-image: none;
  border: 1px solid #ccc;
}
.milestone {
  padding: 0px 12px 0px 120px;
}

.circle {
  width: 7px;
  height: 8px;
  background-color: white;
  border-radius: 100px;
  margin-left: 3px;
}

.milestone_card {
  vertical-align: top;
  cursor: pointer;
  min-width: 160px;
  border: solid 1px #d3dfe4;
  background-color: #fff;
  border-radius: 2px;
  display: inline-block;
  padding: 8px 10px;
  margin: 13px 10px 10px 0;
  min-height: 52px;
}
.selected_milestone {
  background-color: #32557a;
  border-radius: 4px;
  min-height: 52px;
  color: #fff;
  position: relative;
  vertical-align: top;
  min-width: 160px;
  border: solid 1px #d3dfe4;
  display: inline-block;
  margin: 13px 9px 10px 0;
  .fa {
    position: absolute;
    right: 10px;
    top: 8px;
    font-size: 32px;
    color: #488ee1;
  }
  .day_text {
    color: #ddd;
    font-size: 12px;
  }
  .day_card {
    padding: 10px 8px;
    min-width: 180px;
  }
}
.day_text {
  color: #999;
  font-size: 12px;
}
.edit_milestone_link {
  font-size: 12px;
  position: relative;
  color: #4c8ce3;
  cursor: pointer;
}
.disabled-bg {
  pointer-events: none;
  // background-color: #e7ebef;
  /deep/ input {
    // color: red;
    background-color: #e7ebef;
  }
}
.time-picker input.display-time {
  background-color: #e7ebef;
  border-radius: 2px;
}
.pt-40 {
  padding-top: 40px;
}

.form-control {
  border-radius: 2px;
}

.text-color {
  color: #888;
}

.cancelImage {
  color: #959fa4;
  position: absolute;
  right: 10px;
  top: 7px;
  font-size: 24px;
}

.card {
  padding: 15px;
  color: black;
}

.display-day {
  height: 35px !important;
}

.input-color {
  background-color: #f7f7f7;
  border: 1px solid #cccccc;
  border-radius: 3px;
}

.checkbox_position {
  position: relative;
  top: 2px;
}

.view-screen {
  font-size: 10px;
  color: #4c8ce4;
  padding-left: 16px;
}

.opacity-change {
  opacity: 0.5;
}

.required {
  color: #ff0000;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
}
.CohortDIV:hover + .Cohort_hide {
  display: block;
}
.Cohort_hide {
  display: none;
  position: absolute;
  top: 16px;
}
.switch {
  position: relative;
  display: inline-block;
  width: 38px;
  height: 23px;
  margin-top: -1px;
}
/* Hide default HTML checkbox */
.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 2px solid #ccc;
}
.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 2px;
  bottom: 1px;
  background-color: #ccc;
}
input:checked + .slider {
  border: 2px solid #48bf7a;
}
input:checked + .slider:before {
  content: "";
  background-color: #48bf7a;
}
input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}
input:checked + .slider:before {
  /*content: '✓';*/
  position: absolute;
  color: #2ecc71;
  text-align: center;
  font-size: 20px;
  -webkit-transform: translateX(14px);
  -ms-transform: translateX(14px);
  transform: translateX(14px);
}
/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.completion-window {
  background-color: #c5d1d6;
  display: flex;
  padding: 0 4px;
  border-radius: 3px;
  padding: 8px 4px 4px 11px;
  margin-top: -4px;
}
.completion-window > p {
  padding-top: 8px;
  margin: 0;
  font-size: 12px;
  font-family: Roboto;
  line-height: 1.33;
  text-align: left;
  color: #34537d;
}
.completion-window > input {
  border: none;
  width: 50px;
  height: 32px;
  border-radius: 2px;
  text-align: center;
  background-color: #ffffff;
  color: #666669;
  padding: 5px;
}
.add_another_btn {
  font-size: 12px;
  background-color: #1e8fe1;
  border-color: #1e8fe1;
  color: #ffffff;
  margin-bottom: 20px;
  max-width: 120px;
}

.create_milestone_btn {
  font-size: 12px;
  background-color: #f06559;
  border-color: #f06559;
  color: #fff;
  margin-bottom: 20px;
  max-width: 180px;
}
.modal-dialog {
  max-width: 1000px !important;
}
.survey_notification_block {
  width: auto;
  height: auto;
  margin: 5px 31.5px 10px 0px;
  padding: 11px 23px 13px 19px;
  border-radius: 4px;
  border: solid 1px #c5d1d6;
}
.sub-heading-survey-notification {
  width: 230px;
  height: 20px;
  margin: 14px 47px 7px 0;
  font-size: 14px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: left;
  color: #666669;
  font-weight: 600;
}
.w100 {
  width: 100%;
}

.custom-noti-lab {
  opacity: 0.9;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: left;
  color: #666669;
  font-family: "RobotoMedium";
}
.toggle-indicator {
  opacity: 0.8;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: left;
  color: #666669;
}

.xten {
  display: inline-block;
}
.add_a_notification_btn {
  background-color: #4c8ce4;
  font-family: "RobotoRegular";
  font-size: 12px;
  font-weight: normal !important;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
  border-radius: 50px;
  padding: 1px 14px 0px 0px;
  height: auto !important;
  line-height: 24px !important;
}
.add_a_notification_btn:before {
  content: "\f055";
  font-family: "FontAwesome";
  color: white;
  font-size: 26px;
  float: left;
  padding: 0px 6px 0px 2px;
}
.cohortDrop {
  border-radius: 4px;
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.25);
  pointer-events: none;
}
.CohortDIV:hover + .Cohort_hide {
  display: block;
}
.Cohort_hide {
  display: none;
  position: absolute;
  top: 16px;
}
.bt-1 {
  border-top: 1px solid #d3dfe4;
}
.dynamic-activity-scheduler-btn {
  border: 1px solid #999999;
  background-color: #cccccc;
  color: #666666;
  border-radius: 4px;
  font-family: "RobotoRegular";
  font-size: 15px;
  padding: 7px 12px 8px 39px;
  position: relative;
  & .das-icon {
    background: url(/static/img/dynamic-only-blue-icon.svg) no-repeat;
    width: 28px;
    height: 23px;
    float: left;
    position: absolute;
    left: 9px;
    top: 9px;
  }
}
.activity-mode {
  margin-bottom: 22px;
  display: inline-block;
  & span {
    padding: 16px 28px 16px 11px;
    margin-right: 13px;
    border-radius: 3px;
    border: solid 1px #d3dfe4;
    font-size: 15px;
    & img {
      &.selected-mode {
        background-color: #4c8ce4;
      }
      &.unselected-mode {
        background-color: #d3dfe4;
      }
      &.circular-image {
        padding: 6px;
        border-radius: 50%;
        height: 29px;
        width: 29px;
      }
    }
    &.selected {
      background: #34537d;
      border-radius: 3px;
      color: #ffffff;
      border: solid 1px #4c8ce4;
    }
    &:hover {
      cursor: pointer;
    }
    @media screen and (max-width: 768px) {
      margin-right: 5px;
    }
  }
}
.activity-mode-opacity {
  visibility: hidden;
}

.dynamic-only-qs {
  font-weight: 600;
  color: #666669;
  font-size: 13px;
}
.notShownCSS {
  color: #4a4a4a;
  background-color: #eeeeee;
  padding: 2px;
  border-radius: 2px;
  font-family: Roboto;
  margin: -28px -11px 0px 0px;
  float: right;
  font-size: 10px;
}

.selectedNotShownCSS {
  margin: -28px -10px 0px 0px;
}
.survey_b {
  font-weight: 600;
  color: #666769;
}
</style>
